if (!customElements.get('redirection-popup')) {
  customElements.define('redirection-popup', class RedirectionPopup extends HTMLElement {
    constructor() {
      super();
      this.cookieName = 'localePopup'
      this.isCookieSet = false;

      this.usStoreUrl = this.dataset.usUrl
      this.ukStoreUrl = this.dataset.ukUrl
      this.ausStoreUrl = this.dataset.ausUrl

      this.currStoreUrl = window.shopUrl
      this.currStoreCountry = window.Shopify.country

      this.redirectButton = this.querySelector("#locale-redirect-to");
      this.stayButton = this.querySelector("#locale-stay");
      this.closeButton = this.querySelector(".redirection-popup-close");
      this.countryName = this.querySelector(".user-country-name");
      this.targetCountryName = this.querySelector(".user-target-region");
      this.targetCountryNameCTA = this.querySelector(".user-cta-target-region");
      this.currentCountryNameCTA = this.querySelector(".user-current-region");

      this.redirectionStoreFlag = this.querySelector("#locale-redirect-to .flag-icon");

      this.userLocale = '';
      this.userlocaleData = {};
      this.redirectList = [];

      this.redirectList = [
          { user_country_name: "United Kingdom", user_country_code: "GB", redirectURL: this.ukStoreUrl },
          { user_country_name: "United States", user_country_code: "US", redirectURL: this.usStoreUrl },
          { user_country_name: "Australia", user_country_code: "AU", redirectURL: this.ausStoreUrl }
      ];

      // fires init function
      this.init();
    }

    connectedCallback() {
        this.redirectButton.addEventListener('click', () => {
            this.setCookie(this.cookieName, 'showed', 365)
            window.location = this.userlocaleData.redirectURL;
        })
        this.stayButton.addEventListener('click', () => {
            this.setCookie(this.cookieName, 'showed', 365)
            this.close();
        })
        this.closeButton.addEventListener('click', () => {
            this.setCookie(this.cookieName, 'showed', 365)
            this.close();
        })
    }

    async init() {

        // checks if the cookie was already set, which is set once users makes a decision on a popup
        if(this.getCookie(this.cookieName) == 'showed') return


        // Fetches user locale
        await this.checkRegion();


        // checks if user locale is present in redirect list array, shows only if it exists as we dont want to show it on every country
        if(!this.shouldShowPopup() ) return;

        // updated popup content
        this.updatePopupContent();

        // opens a popup
        this.open();
    }

    async checkRegion() {
        await fetch(window.shopUrl +'/browsing_context_suggestions.json')
        // await fetch('/browsing_context_suggestions.json') // use for development
        .then((response)=>response.json())
        .then((responseJson)=>{
            this.userLocale = responseJson?.detected_values?.country?.handle;
            this.redirectList.forEach(item => {
                if(item.user_country_code === this.userLocale) {
                    this.userlocaleData = item;
                }
            })
        })
    }

    updatePopupContent() {
        // this code generates flag svg html fot the redirect to button, ex: is user is from US he will be redirected to US store, so we show US flag
        const flagHtml = `<svg width="23" height="17" xmlns="http://www.w3.org/2000/svg" aria-labelledby="locationName" role="img">
        <title id="locationName">Flag of ${this.userlocaleData.user_country_name }
        </title><image href="https://raw.githubusercontent.com/Fostr-io/fostr_assets/main/country_flags/circle/${this.userlocaleData.user_country_code.toLowerCase()}-circle.svg"
        class="redirection-store-flag"  height="17" width="23" alt="Country flag" loading="lazy" /></svg>`

        this.countryName.innerText = this.userlocaleData.user_country_name;
        this.targetCountryName.innerText = this.userlocaleData.user_country_code;
        this.targetCountryNameCTA.innerText = this.userlocaleData.user_country_code;
        this.currentCountryNameCTA.innerText = this.currStoreCountry;
        this.redirectionStoreFlag.innerHTML = flagHtml;

    }

    shouldShowPopup() {
        // if this.userLocale is empty, it means that the user is not from the list of countries we want to redirect
        if(this.userLocale == undefined || this.userLocale == '') {
            return false
        } else {
            // this code checks if the user locale is present in redirect list array and if the current store url is not the same as the redirect url (meaning user is already on the correct store)
            return this.redirectList.some(item => item.user_country_code === this.userLocale && this.currStoreUrl != item.redirectURL);
        }
    }

    open() {
        this.classList.add('show')
    }
    close() {
        this.classList.remove('show')
    }

    setCookie(cName, cValue, expDays) {
        let date = new Date();
        date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
    }

    getCookie(cookieName) {
        const cookies = document.cookie.split(";");

        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();

            // Check if the cookie starts with the specified name
            if (cookie.startsWith(`${cookieName}=`)) {
                // Get the cookie value by extracting everything after the equals sign
                const value = cookie.substring(cookieName.length + 1);
                return decodeURIComponent(value);
            }
        }

        return false;
    }

  });
}